<template>
  <modal-component
    v-if="modaleVisible"
    v-model="modaleVisible"
    class="erreurs-devant modal-recherche-dr"
    closable
    size="large"
    no-content-scroll
  >
    <template #header>Sélectionner des demandes de remboursement pour la proforma groupée</template>
    <template #content>
      <div class="filtres-row">
        <WrapperInput
          v-model="strRecherche"
          placeholder="N° DR, dispositif, dossier, référence, établissement, montant..."
          class="filtre-input"
        />
        <WrapperDropdownMultiple
          v-model="filtresDispositifs"
          :items="dispositifItems"
          placeholder="Dispositif"
          class="filtre-dropdown"
        />
        <BasicButton
          icon-name="close"
          variant="outlined"
          class="filtre-reset"
          @click="resetFiltres"
        />
      </div>
      <div
        v-if="drFiltrées !== null"
        class="gridWrapper"
      >
        <div class="desktopWrapper">
          <div class="dr-card-row dr-card-row--header">
            <BasicCell :span="2">
              <BasicCheckbox
                v-model="toutSelectionner"
                label=""
                :disabled="!drFiltrées.length"
              />
            </BasicCell>
            <BasicCell
              v-for="(col, i) in headerCols"
              :key="i"
              :span="col.span"
              :extra-class="col.extraClass"
            >
              <BasicSort
                v-if="col.sortable"
                v-model="sortConfig"
                :name="col.sortKey!"
              />
              <span>{{ col.text }}</span>
            </BasicCell>
          </div>
          <div class="dr-content-container">
            <div
              v-if="drTriees?.length"
              class="dr-scroll-container"
            >
              <div
                v-for="dr in drTriees"
                :key="dr.code"
                class="dr-grid-elem"
                :class="{ 'dr-grid-elem--selected': isDRSelectionnee(dr.code) }"
                @click="toggleDRSelection(dr.code)"
              >
                <div class="dr-card-row dr-card-row--clickable">
                  <BasicCell :span="2">
                    <BasicCheckbox
                      :model-value="isDRSelectionnee(dr.code)"
                      label=""
                      @click.stop
                      @update:model-value="toggleDRSelection(dr.code)"
                    />
                  </BasicCell>
                  <BasicCell :span="5">{{ dr.code }}</BasicCell>
                  <BasicCell :span="5">{{ dr.dispositif }}</BasicCell>
                  <BasicCell :span="5"><span>{{ dr.codeDossier || '-' }} <p v-if="dr.referenceInterneDossier">({{ dr.referenceInterneDossier }})</p></span> </BasicCell>

                  <BasicCell :span="5" ><span>{{ dr.reference || '-' }}</span></BasicCell>

                  <BasicCell
                    :span="8"
                    extra-class="elem--nowrap"
                  >
                    {{ dr.etablissementEmetteur?.denomination || '-' }}
                  </BasicCell>
                  <BasicCell
                    :span="6"
                    extra-class="elem--right"
                  >
                    {{ formatMontant(dr.montantHt) }}
                  </BasicCell>
                </div>
              </div>
            </div>

            <EmptyDataTable v-else>
              <template #content>
                Aucune
                <BasicText>demande de remboursement</BasicText>
                disponible
              </template>
            </EmptyDataTable>
          </div>
          <div class="totaux">
            <div class="totaux__row">
              <span>Total : {{ nombreTotalDR }} DR</span>
              <span class="totaux__value">{{ formatMontant(montantTotalDR) }}</span>
            </div>
            <div class="totaux__row totaux__row--highlight">
              <span>Sélection : {{ nombreDRSelectionnees }} DR</span>
              <span class="totaux__value text-highlight">{{ formatMontant(montantDRSelectionnees) }}</span>
            </div>
          </div>
        </div>
        <div class="mobileWrapper">
          <div
            v-if="drFiltrées?.length"
            class="mobile-toolbar"
          >
            <BasicCheckbox
              v-model="toutSelectionner"
              label="Tout"
              :disabled="!drFiltrées.length"
            />
            <span class="mobile-toolbar__stats">
              <span class="mobile-toolbar__count">{{ nombreDRSelectionnees }}/{{ nombreTotalDR }}</span>
              <span class="mobile-toolbar__amount text-highlight">{{ formatMontant(montantDRSelectionnees) }}</span>
            </span>
          </div>
          <div
            v-if="drTriees?.length"
            class="mobileScrollContainer"
          >
            <div
              v-for="dr in drTriees"
              :key="dr.code"
              class="mobileCard"
              :class="{ 'mobileCard--selected': isDRSelectionnee(dr.code) }"
            >
              <div
                class="mobileCard__main"
                @click="toggleDRSelection(dr.code)"
              >
                <BasicCheckbox
                  :model-value="isDRSelectionnee(dr.code)"
                  label=""
                  @click.stop
                  @update:model-value="toggleDRSelection(dr.code)"
                />
                <div class="mobileCard__info">
                  <div class="mobileCard__top">
                    <span class="mobileCard__badge">{{ dr.dispositif }}</span>
                    <span class="mobileCard__code">{{ dr.code }}</span>
                    <span class="mobileCard__montant">{{ formatMontant(dr.montantHt) }}</span>
                  </div>
                  <div class="mobileCard__bottom">
                    {{ dr.etablissementEmetteur?.denomination || '-' }}
                  </div>
                </div>
                <div
                  class="mobileCard__chevron"
                  :class="{ 'mobileCard__chevron--open': expandedCards.has(dr.code) }"
                  @click.stop="toggleExpand(dr.code)"
                >
                  <BasicIcon
                    name="arrow-down"
                    :active="false"
                  />
                </div>
              </div>
              <div
                v-if="expandedCards.has(dr.code)"
                class="mobileCard__drawer"
              >
                <div class="mobileCard__drawer-row">
                  <span class="mobileCard__drawer-label">N° dossier</span>
                  <span class="mobileCard__drawer-value">{{ dr.codeDossier || '-' }}</span>
                </div>
                <div class="mobileCard__drawer-row">
                  <span class="mobileCard__drawer-label">Réf. interne</span>
                  <span class="mobileCard__drawer-value">{{ dr.reference || '-' }}</span>
                </div>
              </div>
            </div>
          </div>
          <EmptyDataTable v-if="!drTriees?.length">
            <template #content>
              Aucune
              <BasicText>demande de remboursement</BasicText>
              disponible
            </template>
          </EmptyDataTable>
        </div>
      </div>
    </template>
    <template #actions>
      <div class="modal-actions">
        <BasicButton
          label="Annuler"
          variant="outlined"
          @click="modaleVisible = false"
          class="modal-btn"
        />
        <BasicButton
          :label="`Ajouter (${nombreDRSelectionnees})`"
          :disabled="nombreDRSelectionnees === 0"
          @click="drAjouter"
          class="modal-btn"
        />
      </div>
    </template>
  </modal-component>
</template>

<script setup lang="ts">
  import { useRechercherDR } from '@/features/interface/demande/proforma/recherche-dr/useRechercherDR.ts'
import EmptyDataTable from '@/features/interface/demande/shared/components/EmptyDataTable.vue'
import ModalComponent from '@/features/interface/modal/ModalComponent.vue'
import { computed, ref } from 'vue'

  const modelValue = defineModel<boolean>({ default: false })

  const {
    strRecherche,
    modaleVisible,
    drAjouter,
    drFiltrées,
    filtresDispositifs,
    dispositifItems,
    resetFiltres,
    toutSelectionner,
    isDRSelectionnee,
    toggleDRSelection,
    nombreTotalDR,
    montantTotalDR,
    nombreDRSelectionnees,
    montantDRSelectionnees,
  } = useRechercherDR(modelValue)

  // Gestion des cards expandées
  const expandedCards = ref<Set<string>>(new Set())

  const toggleExpand = (code: string) => {
    if (expandedCards.value.has(code)) {
      expandedCards.value.delete(code)
    } else {
      expandedCards.value.add(code)
    }
    // Force reactivity
    expandedCards.value = new Set(expandedCards.value)
  }

  const headerCols = computed(() => [
    { span: 5, text: 'N° DR', sortable: true, sortKey: 'code', extraClass: 'elem--sort elem--clickable' },
    { span: 5, text: 'Dispositif', sortable: true, sortKey: 'dispositif', extraClass: 'elem--sort elem--clickable' },
    { span: 5, text: 'N° dossier', sortable: false },
    { span: 5, text: 'Réf. interne', sortable: false },
    {
      span: 8,
      text: 'Établissement',
      sortable: true,
      sortKey: 'etablissement',
      extraClass: 'elem--sort elem--clickable',
    },
    {
      span: 6,
      text: 'Montant HT',
      sortable: true,
      sortKey: 'montant',
      extraClass: 'elem--sort elem--clickable elem--right',
    },
  ])

  const sortConfig = ref<string>('')

  const drTriees = computed(() => {
    if (!drFiltrées.value?.length) return []
    const sorted = [...drFiltrées.value]
    if (!sortConfig.value) return sorted

    // Parse le format "field asc" ou "field desc"
    const [field, direction] = sortConfig.value.split(' ')

    return sorted.sort((a, b) => {
      let aVal: any, bVal: any
      switch (field) {
        case 'code':
          aVal = a.code
          bVal = b.code
          break
        case 'dispositif':
          aVal = a.dispositif
          bVal = b.dispositif
          break
        case 'etablissement':
          aVal = a.etablissementEmetteur?.denomination || ''
          bVal = b.etablissementEmetteur?.denomination || ''
          break
        case 'montant':
          aVal = a.montantHt || 0
          bVal = b.montantHt || 0
          break
        default:
          return 0
      }
      if (typeof aVal === 'string') {
        aVal = aVal.toLowerCase()
        bVal = bVal.toLowerCase()
      }
      const cmp = aVal < bVal ? -1 : aVal > bVal ? 1 : 0
      return direction === 'asc' ? cmp : -cmp
    })
  })

  const formatMontant = (montant: number | null | undefined) => {
    if (montant == null) return '-'
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(montant)
  }
</script>

<style lang="less" scoped>
  @import './index.less';
  @import './DemandeCardMobile.less';

  .modal-recherche-dr {
    :deep(.modal__wrapper) {
      max-width: 90vw;
      width: 1200px;
    }
  }

  .dr-card-row {
    position: relative;
    display: grid;
    align-items: center;
    grid-template-columns: repeat(36, 1fr);
    padding: 0 12px; // Hauteur réduite
    border-bottom: 1px solid @neutral-200;

    // Réduire le padding des cellules
    :deep(.elem) {
      padding: 2px 4px;
    }

    &--header {
      border-radius: 8px 8px 0 0;
      background: @indigo-900;

      :deep(.elem) {
        padding: 4px;
        display: flex;
        justify-content: space-between;

        span {
          color: @white;
          font-weight: 800;
          font-size: 12px;
        }

        &--sort {
          justify-content: flex-start;
        }

        svg {
          fill: @white;
          transform: scale(0.65);
          overflow: visible;
        }
      }
    }

    &--clickable {
      cursor: pointer;

      &:hover {
        background-color: @neutral-100;
      }
    }
  }

  .dr-grid-elem {
    &:nth-child(odd) {
      background-color: @light-blue;
    }

    &:nth-child(even) {
      background-color: @white;
    }

    &--selected {
      .dr-card-row {
        background-color: #dff4ff !important;
      }
    }
  }

  .dr-content-container {
    height: 350px;
    display: flex;
    flex-direction: column;
  }

  .dr-scroll-container {
    flex: 1;
    overflow-y: auto;
  }

  .dr-content-container :deep(.noData) {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  // Filtres en ligne compacte
  .filtres-row {
    display: flex;
    gap: 8px;
    align-items: flex-end;
    margin-bottom: 16px;
  }

  .filtre-input {
    flex: 1;
    min-width: 0;
  }

  .filtre-dropdown {
    width: 180px;
    flex-shrink: 0;
  }

  .filtre-reset {
    min-width: 36px;
    flex-shrink: 0;
  }

  .gridWrapper {
    container-type: inline-size;
  }

  .desktopWrapper {
    display: block !important;
  }

  .mobileWrapper {
    display: none !important;
  }

  .text-highlight {
    color: @persian-600;
  }

  .elem--right {
    justify-content: flex-end;
    text-align: right;
  }

  .elem--nowrap span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  // Totaux desktop
  .totaux {
    margin-top: 16px;
    margin-left: auto;
    width: 50%;
    background-color: @neutral-100;
    border-radius: 8px;
    overflow: hidden;

    &__row {
      display: flex;
      justify-content: space-between;
      padding: 8px 12px;
      font-weight: @font-weight-semibold;
      font-size: @font-size-body-m;
      border-bottom: 1px solid @neutral-200;

      &:last-child {
        border-bottom: none;
      }

      &--highlight {
        background-color: #e8f4fd;
      }
    }

    &__value {
      font-weight: @font-weight-bold;
    }
  }

  // Actions
  .modal-actions {
    display: flex;
    justify-content: space-around;
    width: 100%;
  }

  .modal-btn {
    min-width: 150px;
    padding: 12px 24px;
  }

  // ===== MOBILE =====
  .mobile-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    margin-bottom: 8px;
    border-bottom: 1px solid @neutral-200;

    &__stats {
      display: flex;
      align-items: center;
      gap: 12px;
      font-size: @font-size-body-s;
    }

    &__count {
      color: @neutral-500;
    }

    &__amount {
      font-weight: @font-weight-bold;
    }
  }

  .mobileScrollContainer {
    max-height: 350px; // 5 items max en mobile (~70px par carte)
    overflow-y: auto;
  }

  .mobileCard {
    border: 1px solid @neutral-200;
    border-radius: 6px;
    margin-bottom: 8px;
    overflow: hidden;
    transition: border-color 0.15s;

    &--selected {
      border-color: @persian-500;
      background-color: #f0f9ff;
    }

    &__main {
      display: flex;
      align-items: flex-start;
      gap: 8px;
      padding: 10px;
      cursor: pointer;

      &:active {
        background-color: @neutral-50;
      }
    }

    &__info {
      flex: 1;
      min-width: 0;
    }

    &__top {
      display: flex;
      align-items: center;
      gap: 6px;
      margin-bottom: 4px;
    }

    &__badge {
      background-color: @secondary-100;
      color: @secondary-700;
      padding: 1px 6px;
      border-radius: 3px;
      font-size: 10px;
      font-weight: @font-weight-bold;
    }

    &__code {
      font-weight: @font-weight-bold;
      font-size: @font-size-body-s;
    }

    &__montant {
      margin-left: auto;
      font-weight: @font-weight-bold;
      color: @persian-600;
      font-size: @font-size-body-m;
    }

    &__bottom {
      font-size: @font-size-body-s;
      color: @neutral-600;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__chevron {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      cursor: pointer;
      border-radius: 4px;
      flex-shrink: 0;
      transition: transform 0.2s ease;

      &:hover {
        background-color: @neutral-100;
      }

      svg {
        transform: scale(0.7);
        fill: @neutral-500;
      }

      &--open {
        transform: rotate(180deg);
      }
    }

    &__drawer {
      padding: 0 10px 10px 42px; // Aligné avec le contenu (après la checkbox)
      border-top: 1px solid @neutral-100;
      background-color: @neutral-50;
      animation: slideDown 0.15s ease-out;
    }

    &__drawer-row {
      display: flex;
      justify-content: space-between;
      padding: 6px 0;
      font-size: @font-size-body-s;

      &:not(:last-child) {
        border-bottom: 1px dashed @neutral-200;
      }
    }

    &__drawer-label {
      color: @neutral-500;
    }

    &__drawer-value {
      color: @secondary-1000;
      font-weight: @font-weight-semibold;
    }
  }

  @keyframes slideDown {
    from {
      opacity: 0;
      max-height: 0;
    }
    to {
      opacity: 1;
      max-height: 100px;
    }
  }

  @container (max-width: 768px) {
    .desktopWrapper {
      display: none !important;
    }

    .mobileWrapper {
      display: block !important;
    }

    // Header caché en mobile
    :deep(.modal__header) {
      display: none !important;
    }

    // Réduire padding content
    :deep(.modal__content) {
      padding: 12px !important;
    }

    // Filtres empilés verticalement et compacts
    .filtres-row {
      flex-wrap: wrap;
    }

    .filtre-input {
      flex: 1 1 100%;
      order: 1;
    }

    .filtre-dropdown {
      flex: 1;
      width: auto;
      order: 2;
    }

    .filtre-reset {
      order: 3;
    }

    .gridWrapper {
      margin-top: 12px;
    }

    // Actions compactes
    .modal-actions {
      padding: 8px 0;
    }
  }
</style>
